// extracted by mini-css-extract-plugin
export default {"bannerContainer":"bannerContainer__VqVwYupA","banner":"banner__XM6Q7NMn"};